import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import API from "../../../../helpers/devApi";
import * as Yup from "yup";
import * as Action from "../../_redux/applicantActions";
import {
  swalConfirm,
  swalError,
  swalSuccess,
  swalWarning,
} from "../../../../helpers/swal";
import { Modal, Input as AntInput, Upload } from "antd";
import { is } from "date-fns/locale";
const { Dragger } = Upload;

const _init = {
  document: "",
  name: "",
  file_type: "",
};

const ApplicantFiles = ({ id }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [updateModal, setUpdateModal] = useState({
    open: false,
    id: null,
    name: "",
    document: "",
    file_type: "",
  });
  const [applicantFile, setApplicantFile] = useState([]);

  const handleSaveFile = async (values) => {
    const formData = new FormData();
    for (let key of Object.keys(values)) {
      formData.append(key, values[key]);
    }
    const response = await API.post(
      "hrms_applicant/save-applicant-document",
      formData
    );
    if (response.data.success) {
      swalSuccess(response.data.message);
      closeUpdateModal();
      fetchData();
    } else {
      swalError(response.data.message);
    }
  };

  const openUpdate = (id, name, file_type, document) => {
    setUpdateModal({
      ...updateModal,
      name,
      file_type,
      document,
      open: true,
      id: id,
    });
  };
  const closeUpdateModal = () => {
    setUpdateModal({
      open: false,
      id: null,
      name: "",
      document: "",
      file_type: "",
    });
  };
  const onUpdate = async (id, values) => {
    const formData = new FormData();
    for (let key of Object.keys(values)) {
      formData.append(key, values[key]);
    }
    const response = await API.patch(
      "hrms_applicant/update-applicant-document/" + id,
      formData
    );
    if (response.data.success) {
      swalSuccess(response.data.message);
      closeUpdateModal();
      fetchData();
    } else {
      swalError(response.data.message);
    }
  };
  const onDelete = (fileId) => {
    Modal.confirm({
      title: "Confirmation Delete",
      content: "Are you sure, You want to delete this file ?",
      onOk: async () => {
        const response = await API.delete(
          "hrms_applicant/delete-applicant-document/" + fileId
        );
        if (response.data.success) {
          swalSuccess("Deleted Successfully");
          const files = applicantFile.filter((item) => item.id !== fileId);
          setApplicantFile(files);
          closeUpdateModal();
          if (!files.length) {
            dispatch(
              Action.updateProfileScore(
                {
                  name: ["Document"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
          }
          // fetchData();
        } else {
          swalError(response.data.message);
        }
      },
    });
  };
  const fetchData = async () => {
    const response = await API.get(
      "hrms_applicant/get-applicant-document/" + id
    );
    if (response.data.success) {
      // console.log(response);
      if (response.data.data.length) {
        setApplicantFile(
          response.data.data.map((d) => {
            return {
              id: d.id,
              document: d.document,
              name: d.name,
              file_type: d.file_type,
            };
          })
        );
      }
    } else {
      swalError(response.data.message);
    }
  };
  const saveOrUpdate = async () => {
    if (!updateModal?.name || !updateModal?.document) {
      swalWarning("Please Fillup all The Field");
      return;
    }
    if (updateModal.id) {
      await onUpdate(updateModal.id, {
        name: updateModal.name,
        document: updateModal.document,
        file_type: updateModal.file_type,
        applicant_id: id,
        api_url: process.env.REACT_APP_API_URL.replace("/api/v1", ""),
      });
    } else {
      await handleSaveFile({
        name: updateModal.name,
        document: updateModal.document,
        file_type: updateModal.file_type,
        applicant_id: id,
        api_url: process.env.REACT_APP_API_URL.replace("/api/v1", ""),
      });

      dispatch(
        Action.createProfileScore(
          {
            name: ["Document"],
            applicant_id: id,
          },
          () => {
            dispatch(Action.getApplicantPersonalInfo(id));
          }
        )
      );
    }
  };
  useEffect(() => {
    if (id) {
      // get-objective
      fetchData();
    }
  }, [id]);
  return (
    <div className="card card_body_box mb-5">
      <div className="card_header_with_edit_btn">
        <div className="title">
          <h2>Document Upload</h2>
        </div>
      </div>

      <div className="card-body">
        <button
          onClick={() => {
            openUpdate(null);
          }}
          className="btn btn-md btn-primary"
          style={{ float: "right" }}
        >
          <i className="fa fa-upload"></i> Upload Document
        </button>
        <p style={{ clear: "both", display: "table", content: " " }}></p>
        <div className="row">
          {applicantFile.map((file, index) => {
            return (
              <FilePreview
                {...file}
                key={file.id}
                openUpdate={openUpdate}
                onDelete={onDelete}
              />
            );
          })}
        </div>
        <p style={{ clear: "both", display: "table", content: " " }}></p>
        {updateModal.open ? (
          <FileEditModal
            updateModal={updateModal}
            saveOrUpdate={saveOrUpdate}
            closeUpdateModal={closeUpdateModal}
            setUpdateModal={setUpdateModal}
          />
        ) : null}
      </div>
    </div>
  );
};

const renderPreview = (selectedFile) => {
  if (!selectedFile) return null;

  const { type, name } = selectedFile;

  if (type.startsWith("image/")) {
    // Preview for images
    return (
      <img
        src={URL.createObjectURL(selectedFile)}
        alt="preview"
        style={{
          width: "100%",
          maxHeight: "200px",
          objectFit: "contain",
          marginBottom: "10px",
        }}
      />
    );
  } else if (type === "application/pdf") {
    // Preview for PDF
    return (
      <iframe
        src={URL.createObjectURL(selectedFile)}
        style={{
          width: "100%",
          height: "400px",
          border: "1px dashed #40a9ff",
          marginBottom: "10px",
        }}
        title="PDF Preview"
      />
    );
  } else {
    // Show file name for unsupported previews
    return (
      <div>
        <p style={{ marginBottom: "10px" }}>{name}</p>
        This is a Word document preview. You have to save form to show file !!
      </div>
    );
  }
};

const preview = (selectedFile) => {
  console.log({ selectedFile }, "++++++++++++++++++");
  const ext = selectedFile?.split(".").pop();
  const isDoc = ext === "doc" || ext === "docx";
  const isPdf = ext === "pdf";

  // Construct the file URL
  const fileUrl = isDoc
    ? `https://view.officeapps.live.com/op/embed.aspx?src=${
        process.env.REACT_APP_DOC_CONTAINER
      }${selectedFile}${process.env.REACT_APP_DOC_TOKEN.replace(/&/g, "%26")}`
    : `${process.env.REACT_APP_DOC_CONTAINER}${selectedFile}${
        isPdf
          ? "&rsct=application%2Fpdf&embedded=true"
          : process.env.REACT_APP_DOC_TOKEN
      }`;
  //'&rsct=application%2Fpdf&embedded=true'
  const fileUrl1 =
    process.env.REACT_APP_DOC_CONTAINER +
    selectedFile +
    process.env.REACT_APP_DOC_TOKEN +
    (ext === "pdf" ? "&rsct=application%2Fpdf&embedded=true" : "");

  if (isDoc) {
    return (
      <object
        data={fileUrl}
        style={{
          maxWidth: "100%",
          height: "200px",
          border: "1px dashed #40a9ff",
        }}
        type={isPdf ? "application/pdf" : undefined}
        aria-label={`${selectedFile} Preview`}
      />
    );
  } else {
    return (
      <object data={fileUrl1} style={{ maxWidth: "100%", height: "200px" }} />
    );
  }
};

const FileEditModal = ({
  updateModal,
  closeUpdateModal,
  setUpdateModal,
  saveOrUpdate,
}) => {
  // const fileUrl = useMemo(() => {
  //   const ext = updateModal.document?.split(".").pop();
  //   const isDoc = ext === "doc" || ext === "docx";
  //   const isPdf = ext === "pdf";

  //   // Construct the file URL
  //   const fileUrl = isDoc
  //     ? `https://view.officeapps.live.com/op/embed.aspx?src=${
  //         process.env.REACT_APP_DOC_CONTAINER
  //       }${document}${process.env.REACT_APP_DOC_TOKEN.replace(/&/g, "%26")}`
  //     : `${process.env.REACT_APP_DOC_CONTAINER}${document}${
  //         isPdf
  //           ? "&rsct=application%2Fpdf&embedded=true"
  //           : process.env.REACT_APP_DOC_TOKEN
  //       }`;
  //   //'&rsct=application%2Fpdf&embedded=true'
  //   const fileUrl1 =
  //     process.env.REACT_APP_DOC_CONTAINER +
  //     document +
  //     process.env.REACT_APP_DOC_TOKEN +
  //     (ext === "pdf" ? "&rsct=application%2Fpdf&embedded=true" : "");
  //   return isDoc ? fileUrl : fileUrl1;
  // }, [updateModal.document]);
  // console.log(fileUrl)
  return (
    <Modal
      open={true}
      onCancel={() => {
        closeUpdateModal();
      }}
      okText={updateModal.id ? "Update" : "Save"}
      onOk={saveOrUpdate}
    >
      <div>
        <label>Name of the Document</label>
        <AntInput
          value={updateModal.name}
          onChange={(e) =>
            setUpdateModal({ ...updateModal, name: e.target.value })
          }
          style={{ width: "100%" }}
        />
      </div>
      <div>
        <label>Upload Document</label>
        {console.log({ updateModal }, "+++++++++++++")}
        <Dragger
          fileList={[]}
          accept=".png,.jpg,.jpeg,.pdf,.doc,.docx"
          multiple={false}
          action={false}
          beforeUpload={() => false}
          onChange={({ file }) => {
            console.log(file);
            setUpdateModal({ ...updateModal, document: file });
          }}
        >
          {typeof updateModal.document == "string"
            ? preview(updateModal.document)
            : renderPreview(updateModal.document)}

          <p className="my-5 py-5">Upload File</p>
        </Dragger>
        <small>
          Personalized CV, NID, All Academic Certificates and Transcripts,
          Passport, TIN Certificate, and any other relevant document
        </small>
      </div>
    </Modal>
  );
};

const FilePreview = ({
  id,
  document,
  name,
  file_type,
  openUpdate,
  onDelete,
}) => {
  // const fileUrl =
  //   document instanceof File ? URL.createObjectURL(document) : document;
  const ext = document?.split(".").pop();
  const isDoc = ext === "doc" || ext === "docx";
  const isPdf = ext === "pdf";

  // Construct the file URL
  const fileUrl = isDoc
    ? `https://view.officeapps.live.com/op/embed.aspx?src=${
        process.env.REACT_APP_DOC_CONTAINER
      }${document}${process.env.REACT_APP_DOC_TOKEN.replace(/&/g, "%26")}`
    : `${process.env.REACT_APP_DOC_CONTAINER}${document}${
        isPdf
          ? "&rsct=application%2Fpdf&embedded=true"
          : process.env.REACT_APP_DOC_TOKEN
      }`;

  console.log({ ext });
  //'&rsct=application%2Fpdf&embedded=true'
  const fileUrl1 =
    process.env.REACT_APP_DOC_CONTAINER +
    document +
    process.env.REACT_APP_DOC_TOKEN +
    (ext === "pdf" ? "&rsct=application%2Fpdf&embedded=true" : "");
  return (
    <div className="col-md-4">
      <div>
        <h4>{name}</h4>
        {isDoc ? (
          <object
            data={fileUrl}
            style={{
              maxWidth: "100%",
              height: "200px",
              border: "1px dashed #40a9ff",
            }}
            type={isPdf ? "application/pdf" : undefined}
            aria-label={`${name} Preview`}
          />
        ) : (
          <object
            data={fileUrl1}
            style={{ maxWidth: "100%", height: "200px" }}
          />
        )}
        <div>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => openUpdate(id, name, file_type, document)}
          >
            <i className="fa fa-edit"></i>
          </button>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => onDelete(id)}
          >
            <i className="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplicantFiles;
